<template>
  <div>
    <div 
      class="upload-area" 
      :class="{ 'dragover': isDragging, 'uploading': uploading }"
      @dragover.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      @drop.prevent="handleFileDrop"
      @click="triggerFileInput">
      <input 
        type="file" 
        ref="fileInput" 
        accept=".csv"
        @change="handleFileSelect"
        style="display: none">
      <i class="cloud upload icon"></i>
      <p class="upload-text">Click to upload or drag and drop</p>
      <p class="upload-hint">CSV file up to 10MB</p>
    </div>
    <div v-if="uploadedFile" class="uploaded-file">
      <i class="file icon"></i>
      <span>{{ uploadedFile.name }}</span>
      <button class="remove-file" @click="removeFile">
        <i class="times icon"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploadArea',
  props: {
    uploading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isDragging: false,
      uploadedFile: null
    }
  },
  methods: {
    triggerFileInput: function () {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click()
      }
    },
    handleFileSelect: function (event) {
      const file = event.target.files[0]
      if (file) {
        this.validateAndSetFile(file)
      }
    },
    handleFileDrop: function (event) {
      this.isDragging = false
      const file = event.dataTransfer.files[0]
      if (file) {
        this.validateAndSetFile(file)
      }
    },
    validateAndSetFile: function (file) {
      // Validate file type
      if (!file.name.toLowerCase().endsWith('.csv')) {
        this.$emit('error', 'Invalid file type. Please upload a CSV file.')
        return
      }
      
      // Validate file size (10MB = 10 * 1024 * 1024 bytes)
      const maxSize = 10 * 1024 * 1024
      if (file.size > maxSize) {
        this.$emit('error', 'File size exceeds 10MB limit. Please upload a smaller file.')
        return
      }
      
      this.uploadedFile = file
      this.$emit('file-selected', file)
    },
    removeFile: function () {
      this.uploadedFile = null
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
      this.$emit('file-removed')
    }
  }
}
</script>

<style scoped>
@import './styles/FileUploadArea.css';
</style>




// WEBPACK FOOTER //
// FileUploadArea.vue?6ded189a